import React from "react";
import { Chip } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const StatusChip = ({ item }) => {
  if (item.approved)
    return (
      <Chip
        label="אושר"
        size="small"
        icon={<CheckCircleIcon style={{ color: "#fff", fontSize: 14 }} />}
        sx={{
          bgcolor: "#4caf50",
          color: "#fff",
          fontWeight: 700,
          fontSize: "0.72rem",
          height: 22,
        }}
      />
    );
  if (item.chariaga)
    return (
      <Chip
        label="חריגה"
        size="small"
        icon={<WarningAmberIcon style={{ color: "#fff", fontSize: 14 }} />}
        sx={{
          bgcolor: "#e65100",
          color: "#fff",
          fontWeight: 700,
          fontSize: "0.72rem",
          height: 22,
        }}
      />
    );
  return (
    <Chip
      label="ממתין"
      size="small"
      sx={{
        bgcolor: "#e0e0e0",
        color: "#555",
        fontWeight: 700,
        fontSize: "0.72rem",
        height: 22,
      }}
    />
  );
};

export default StatusChip;
